<template>
  <section class="app-info" dir="rtl">

    <div class="app-info__head">
      <span class="app-info__label">عن التطبيق</span>
    </div>

    <div class="app-info__list">
      <router-link
        v-for="item in items"
        :key="item.slug"
        :to="{ name: 'StaticPage', params: { slug: item.slug } }"
        class="app-info__row"
      >
        <div class="app-info__row-left">
          <i :class="item.icon" class="app-info__row-icon"></i>
          <span class="app-info__row-label">{{ item.title }}</span>
        </div>
        <i class="fa fa-chevron-left app-info__row-arrow"></i>
      </router-link>
    </div>

    <div class="app-info__version">
      وِجْهَة · النسخة 1.0
    </div>

  </section>
</template>

<script setup>
// Static list — no API call needed, just hardcoded slugs
// that match what's in the database
const items = [
  { slug: "about-us",         title: "من نحن",             icon: "fa fa-circle-info" },
  { slug: "terms-of-service", title: "شروط الاستخدام",     icon: "fa fa-file-contract" },
  { slug: "privacy-policy",   title: "سياسة الخصوصية",     icon: "fa fa-shield-halved" },
  { slug: "content-policy",   title: "سياسة المحتوى",     icon: "fa-solid fa-clipboard-check" },
];
</script>

<style scoped lang="scss">
.app-info {
  padding: var(--space-4) var(--page-padding-x) var(--space-2);
  border-top: 1px solid var(--color-border);
  margin-top: var(--space-2);

  &__head {
    margin-bottom: var(--space-3);
  }

  &__label {
    font-size: 0.78rem;
    font-weight: 800;
    color: var(--color-text-4);
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  &__list {
    display: flex;
    flex-direction: column;
    background: var(--color-panel);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-lg);
    overflow: hidden;
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px var(--space-4);
    border-bottom: 1px solid var(--color-border-soft);
    text-decoration: none;
    transition: background 0.15s;

    &:last-child { border-bottom: none; }
    &:hover { background: var(--color-card); }

    &-left {
      display: flex;
      align-items: center;
      gap: var(--space-3);
    }

    &-icon {
      width: 30px; height: 30px;
      border-radius: var(--radius-md);
      background: var(--color-signal-soft);
      border: 1px solid var(--color-signal-glow);
      color: var(--color-signal);
      display: flex; align-items: center; justify-content: center;
      font-size: 0.78rem; flex-shrink: 0;
    }

    &-label {
      font-size: 0.88rem;
      font-weight: 600;
      color: var(--color-text-1);
    }

    &-arrow {
      font-size: 0.68rem;
      color: var(--color-text-4);
    }
  }

  &__version {
    margin-top: var(--space-3);
    text-align: center;
    font-size: 0.68rem;
    color: var(--color-text-4);
    font-family: var(--font-mono);
  }
}
</style>